import { helper } from '@ember/component/helper';
import { StateMachine } from 'uplisting-frontend/utils';

export function stateIs([stateMachine, name]: [StateMachine, string]): boolean {
  return stateMachine.is(name);
}

export default helper(stateIs);
